import PwdComponent from "./passwordInput.vue"
import {
  EventBus
} from "./passwordInputEventBus"

const defaultOptions = {
  version: 1,
  titleBackground: 'black',
  password: ''
};

const PwdPlugin = {
  install(Vue, options) {

    // Merge  opzioni default con arg options
    let userOptions = { ...defaultOptions, ...options };

    // Registro il componente
    Vue.component('passwordInput', PwdComponent)

    // Memorizzo le opzioni
    Vue.prototype.$pwdOptions = userOptions

    Vue.prototype.$passwordInput = {

      open(title, msg, pwd) {
        return new Promise((resolve, reject) => {

          EventBus.$emit('PwdOpen', resolve, reject, title, msg, pwd)

        });

      },

    }

  }
}

export default PwdPlugin
